import React, { Component } from "react";
import { Row, Col } from "reactstrap";

import { getMessage } from "CONFIG/i18n";

//less files
import "../SplashScreen/SplashScreen.less";
import "./LoadingScreen.less";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import { APP_CONFIG } from "UTILS/Constants";

class LoadingScreen extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedLanguage: this.props.selectedLanguage,
      offline: null
    };
  }
  
  componentDidMount() {
    window.addEventListener('offline', () => { this.setState({offline: true}) });
    window.addEventListener('online', () => { this.props.joinAgain(this.state.offline); this.setState({offline: false}) });    
  }

  render() {
    return (
      <div className="loadingScreen callingScreen px-4">
        <div>
          <Row className="displayBlockIE">
            <Col className="logoImage flexForImage pt-3">
              {this.props.logoUrl ? this.props.isLogoPresent === false ? <img src={this.props.logoUrl} />: <img src={this.props.logoUrl}/>: null}
            </Col>
          </Row>
          {this.props.showMeetingEnded ? (
            <Row className="displayBlockIE">
              <Col className="logoImage flexForImage">
                <label className="agentJoinLabel">
                  {getMessage("MEETING_ENDED")}
                </label>
              </Col>
            </Row>
          ) : (
            <React.Fragment>
              <Row className="displayBlockIE">
                <Col className="logoImage flexForImage pt-2">
                  <label className="waitingLabel">
                    {getMessage("THANK_YOU")}
                  </label>
                </Col>
              </Row>
              <Row className="displayBlockIE">
                <Col className="logoImage flexForImage">
                  <label className="agentJoinLabel">
                    {getMessage("AGENT_WILL_JOIN")}
                  </label>
                </Col>
              </Row>
              <Row className="displayBlockIE">
                <Col className="logoImage flexForImage pt-2">
                  {/* <Loader type="Oval" color="#00BFFF" height={40} width={40} /> */}
                  <div className="roundLoader"></div>
                  {" "}
                </Col>
              </Row>
            </React.Fragment>
          )}
        </div>
      </div>
    );
  }
}

export default LoadingScreen;
